/* eslint-disable */
import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";

import { useTranslation } from "react-i18next";

// Material UI table
import { MaterialReactTable } from "material-react-table";
//Material UI components for rendring menu and others
import { Box, MenuItem } from "@mui/material";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import AddLabelModal from "components/Common/Modal/AddLabelModal";
import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";

//import images
import { assetImages } from "constants";

import TabsHeader from "components/Common/TabsHeader/TabsHeader";

//import common header objects
import { commonHeaderLinkLists } from "helper/ClinicalManagementHelper/ClinicalManagementHelper";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import { createContactChatHandler } from "helper/AppUserHelper/AppUserHelper";
import { replaceListByIds, updateListByIds } from "helper/Common/CommonHelper";
import { removeTagHandler } from "helper/TagHelper/TagHelper";

import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";
import DeleteWarningModal from "components/Common/Modal/DeleteWarningModal";
import CompanyListFilterPopup from "./Popup/CompanyListFilterPopup";
import HealthCenterListHeader from "./Header/HealthCenterListHeader";

const HealthCentersListBody = () => {
  /* ------------- Language translation imports starts here ------------- */
  const { t, i18n } = useTranslation();

  const moduleAccess = localStorage.getItem("moduleaccess");
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [isLoading, setIsLoading] = useState(false);
  const [companyList, setCompanyList] = useState([]);
  const [isDataReady, setIsDataReady] = useState(false);

  //optionally, you can manage the row selection state yourself
  const [rowSelection, setRowSelection] = useState({});
  const [selectedCompanyIds, setSelectedCompanyIds] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedTagId, setSelectedTagId] = useState(null);

  const [reloadData, setReloadData] = useState(false);
  const [isFilterReset, setIsFilterReset] = useState(false);

  // json filter query
  const [jsonFilterQuery, setJsonFilterQuery] = useState([]);

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  //function for get all companies
  const getAllCompanyList = async () => {
    setRowSelection({});
    setSelectedCompanyIds([]);

    try {
      setIsLoading(true);

      let requestUrl = `${url.API_BASE_URL}${url.API_GET_ALL_COMPANY}?token=${token}&modulefrom=backend`;

      console.log("url of company list------>", requestUrl);

      const response = await getData(requestUrl);

      console.log("response in company list------>", response);

      if (response.status) {
        setMessageType("success");
        setCompanyList(response.data);
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    } finally {
      setIsLoading(false);
      setIsDataReady(true);
      setShowAlert(true);
    }
  };

  //function for get filtered companies
  const getFilteredCompanyList = async () => {
    try {
      setIsLoading(true);

      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_FILTERED_COMPANY_LIST +
        `?token=${token}`;

      console.log("Original jsonFilterQuery:", jsonFilterQuery);

      // Sanitize the jsonFilterQuery
      const sanitizedQuery = jsonFilterQuery.map((filter) => {
        if (
          (filter.operator === "includes" || filter.operator === "excludes") &&
          Array.isArray(filter.value)
        ) {
          return {
            ...filter,
            value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
          };
        }
        return filter;
      });

      console.log("Sanitized jsonFilterQuery:", sanitizedQuery);

      const filterData = {
        filters: sanitizedQuery,
      };

      const response = await postData(requestUrl, filterData);

      console.log("json filter query response ------->", response);

      if (response.status) {
        setMessageType("success");
        setCompanyList(response.data);
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      console.log(error.message);
      setMessageType("error");
      setAlertMessage(error.message);
    } finally {
      setIsLoading(false);
      setIsDataReady(true);
      setShowAlert(true);
    }
  };

  //function for change rank
  const rankInputChangeHandler = (row, value) => {
    const updatedCompanyList = [...companyList];

    const rowIndex = updatedCompanyList.findIndex(
      (company) => company._id === row.original._id
    );

    if (rowIndex !== -1) {
      updatedCompanyList[rowIndex].rank = value;
      setCompanyList(updatedCompanyList);
    }
  };

  //function for update rank
  const bulkUpdateHandler = async () => {
    if (selectedCompanyIds.length > 0) {
      try {
        const companyListToBeUpdate = companyList.filter((item) =>
          selectedCompanyIds.includes(item._id)
        );

        let companyData = {
          companylist: companyListToBeUpdate,
        };

        let requestURL =
          url.API_BASE_URL + url.API_UPDATE_BULK_COMPANY + `?token=${token}`;

        const response = await putData(requestURL, companyData);

        console.log(response);

        if (response.status) {
          setMessageType("success");

          setTimeout(() => {
            setSelectedCompanyIds([]);
            setRowSelection({});
          }, 1500);
        } else {
          setMessageType("error");
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setAlertMessage("Please select at least one company");
      setMessageType("error");
    }
    setShowAlert(true);
  };

  //function for change status
  const bulkDeleteHandler = async () => {
    if (selectedCompanyIds.length > 0) {
      try {
        const companyListToBeDelete = companyList.filter((item) =>
          selectedCompanyIds.includes(item._id)
        );

        let companyData = {
          companylist: companyListToBeDelete,
        };

        let requestURL =
          url.API_BASE_URL + url.API_DELETE_BULK_COMPANY + `?token=${token}`;

        const response = await putData(requestURL, companyData);

        console.log(response);

        if (response.status) {
          setMessageType("success");

          setTimeout(() => {
            setCompanyList((prevList) =>
              prevList.filter((item) => !selectedCompanyIds.includes(item._id))
            );
          }, 1500);
        } else {
          setMessageType("error");
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setAlertMessage("Please select at least one company");
      setMessageType("error");
    }
    setShowAlert(true);
  };

  //function for remove tag from lead
  const removeTagFromCompany = async (tagIds, componentId) => {
    try {
      const componentUrl = url.API_ADD_REMOVE_TAG_COMPANY;
      const data = await removeTagHandler(tagIds, componentId, componentUrl);

      // console.log("response in remove tag from lead------->", data);

      if (data) {
        afterModalActionClose(data);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setTimeout(() => {
        setSelectedTagId(null);
        setSelectedCompany(null);
      }, 1000);
    }
  };

  const afterModalActionClose = (data = []) => {
    setTimeout(() => {
      setCompanyList((prev) => replaceListByIds(prev, data));
    }, 1000);
  };

  const resetFilterData = () => {
    setJsonFilterQuery([]);
    setIsFilterReset(true);
    setReloadData(true);
  };

  /*
   * Material React Table Column and States -----------------------------------------------------------
   *---------------------------------------------------------------------------------------------------
   */

  //material table columns array
  const initialTableColumns = [
    {
      accessorKey: "name",
      header: t("Name"),
      size: 300,
      Cell: ({ row }) => (
        <div className="company-name border-bottom-0">
          <div className="company-info">
            <div className="d-flex align-items-center gap-3 mb-1">
              <img
                className="rounded-circle mt-1"
                height={40}
                width={40}
                src={
                  row.original.companylogo === ""
                    ? assetImages.defaultUser
                    : url.SERVER_URL + row.original.companylogo
                }
                alt="logo"
              />

              <p className="fs-md">{row.original.name}</p>
            </div>
          </div>
        </div>
      ),
    },
    {
      accessorKey: "tagstring",
      header: t("Label"),
      size: 300,
      Cell: ({ row }) => (
        <div className="label-wrapper py-1">
          <div className="d-flex gap-2">
            <div
              className={
                row.original.taglist.length > 0
                  ? "label-container flex-grow-1"
                  : "d-none"
              }
            >
              <ul
                className="d-flex flex-wrap gap-2 m-0 p-0"
                style={{ listStyle: "none" }}
              >
                {row.original.taglist.map((tag, index) => (
                  <li key={index} className="d-inline-flex">
                    <div className="badge d-flex align-items-center px-3 py-2 border-0 gradient-light text-black rounded-pill">
                      <span className="badge-text fs-xs fw-medium me-1">
                        {tag.title}
                      </span>
                      <Link
                        to="#"
                        className={`${
                          tag.moderator.toString() ===
                            userInfo._id.toString() ||
                          userInfo.role.slug === "ADMIN" ||
                          userInfo.role.slug === "SUPER_ADMIN"
                            ? "d-block"
                            : "d-none"
                        }`}
                        onClick={() => {
                          setSelectedCompany(row.original._id);
                          setSelectedTagId(tag._id);
                          removeTagFromCompany([tag._id], row.original._id);
                        }}
                      >
                        {selectedTagId &&
                        selectedTagId === tag._id &&
                        selectedCompany &&
                        selectedCompany === row.original._id ? (
                          <div
                            className="spinner-border spinner-border-sm text-primary ms-1"
                            role="status"
                            style={{ height: "12px", width: "12px" }}
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        ) : (
                          <span
                            className="d-block text-primary material-symbols-outlined icon-sm ms-1"
                            style={{ cursor: "pointer" }}
                          >
                            cancel
                          </span>
                        )}
                      </Link>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
            <button
              className="btn btn-light btn-sm rounded-circle p-1 shadow-sm border-0 d-flex align-items-center justify-content-center mt-1"
              style={{ width: "24px", height: "24px" }}
              data-bs-toggle="modal"
              data-bs-target="#addLabelModal"
              onClick={() => setSelectedCompanyIds([row.original._id])}
            >
              <span
                className="material-symbols-outlined text-primary"
                style={{ fontSize: "16px" }}
              >
                add
              </span>
            </button>
          </div>
        </div>
      ),
    },
    {
      accessorKey: "email",
      header: t("Email"),
    },
    {
      accessorKey: "rank",
      header: t("Rank"),
      Cell: ({ row }) => (
        <div className="ranking border-bottom-0">
          {row.original.moderator.toString() === userInfo._id.toString() ||
          userInfo.role.slug === "ADMIN" ||
          userInfo.role.slug === "SUPER_ADMIN" ? (
            <input
              type="number"
              className="form-control fs-sm text-gray bg-white py-2 border-gray-300 shadow-none"
              style={{ width: "80px" }}
              value={row.original.rank}
              onChange={(e) => rankInputChangeHandler(row, e.target.value)}
            />
          ) : (
            <p className="ps-3">{row.original.rank}</p>
          )}
        </div>
      ),
    },
    {
      accessorKey: "location",
      header: t("Location"),
      size: 200,
    },
    {
      accessorKey: "ownerfullname",
      header: t("Created By"),
      size: 200,
      Cell: ({ row }) => (
        <div className="d-flex border-bottom-0">
          <div className="d-flex align-items-center gap-2">
            <div
              className="avatar rounded-circle overflow-hidden"
              style={{ width: "25px", height: "25px" }}
            >
              <img
                src={
                  row.original.ownerimage == ""
                    ? assetImages.defaultUser
                    : url.SERVER_URL + row.original.ownerimage
                }
                alt="admin"
                className="w-100 h-100 object-fit-cover object-center"
              />
            </div>
            <p>{row.original.ownerfullname}</p>
          </div>
          <button
            onClick={() => {
              createContactChatHandler(
                row.original.moderator,
                "MOD_COMPANY",
                row.original._id,
                row.original.name
              );
            }}
            className={
              row.original.moderator?.toString() === userInfo._id.toString()
                ? "d-none"
                : "d-flex align-items-center ms-auto border-0 bg-light"
            }
          >
            <span className="d-block material-symbols-outlined icon-md text-primary">
              chat
            </span>
          </button>
        </div>
      ),
    },
    //follower
    {
      accessorKey: "followersnames",
      header: t("Followers"),
      size: 250,
      Cell: ({ row }) =>
        row.original.followerslist.map((follower, index) => (
          <div className="owner border-bottom-0 d-flex gap-1 mb-1" key={index}>
            <img
              className="rounded-circle"
              height={15}
              width={15}
              src={
                follower.image == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + follower.image
              }
              alt="Babcock"
            />

            <p>
              <span className="d-block">{follower.fullname}</span>
            </p>
            <button
              onClick={() => {
                createContactChatHandler(row.original._id);
              }}
              className={
                follower._id === userInfo._id
                  ? "d-none"
                  : "d-flex align-items-center ms-auto border-0 bg-light"
              }
            >
              <span className="d-block material-symbols-outlined icon-md text-primary">
                chat
              </span>
            </button>
          </div>
        )),
    },
    {
      accessorKey: "country",
      header: t("Country"),
    },
    {
      accessorKey: "companytypename",
      header: t("Type"),
    },
    {
      accessorKey: "phone",
      header: t("Phone"),
      Cell: ({ row }) => (
        <div className="phone border-bottom-0">
          <p className="d-flex align-items-center gap-1">
            <span className="d-block material-symbols-outlined icon-sm">
              phone_in_talk
            </span>
            <Link to="#"> {row.original.phone}</Link>
          </p>
        </div>
      ),
    },
    {
      accessorKey: "membercount",
      header: t("Team"),
    },
    {
      accessorKey: "createddate",
      header: t("Created Date"),
    },
  ];

  /* Material React Table Column and States */
  const columns = useMemo(
    () => initialTableColumns,
    [companyList, selectedTagId, i18n.language]
  );

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key]
    );

    if (selectedIdsArray.length > 0) {
      setSelectedCompanyIds(selectedIdsArray);
    } else {
      setSelectedCompanyIds([]);
    }
  }, [rowSelection]);

  useEffect(() => {
    if (jsonFilterQuery.length > 0) {
      getFilteredCompanyList();
    }
  }, [jsonFilterQuery]);

  useEffect(() => {
    if (reloadData) {
      getAllCompanyList();
      setIsFilterReset(true);
      setReloadData(false);
    }
  }, [reloadData]);

  useEffect(() => {
    getAllCompanyList();
  }, []);

  /* Closes the alert by updating the state variables.*/
  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    (moduleAccess.includes("MOD_CLINIC_MANAGEMENT") &&
      moduleAccess.includes("MOD_HEALTH_CENTER_MANAGEMENT"))
  ) {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <TabsHeader
            commonHeaderObject={commonHeaderLinkLists(t)}
            activeOption={t("Health Centers")}
          />
          <div className="container-fluid px-lg-5">
            <HealthCenterListHeader
              reloadList={resetFilterData}
              jsonfilterQuery={jsonFilterQuery}
              selectedItemIds={selectedCompanyIds}
            />

            {/* --------- table / pivot area --------- */}
            {!isDataReady || isLoading ? (
              <LoadingSkeleton />
            ) : (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns} // map columns to be displayed with api data,
                  data={companyList} // data from api to be displayed
                  enableGrouping
                  enableRowSelection // enable showing checkbox
                  getRowId={(row) => row._id} // map which value to select with row checkbox
                  onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
                  state={{
                    rowSelection,
                  }} //pass our managed row selection state to the table to use
                  initialState={{
                    rowSelection,
                  }}
                  // enableRowActions // show the action column
                  enableColumnOrdering={true}
                  enableRowActions // show the action column
                  renderRowActionMenuItems={({ row }) => [
                    <MenuItem
                      key="edit"
                      //onClick={() => console.info(row.id)}
                    >
                      <Link
                        className="dropdown-item"
                        to={`/admin/clinicalmanagement/healthcenters/save/${row.id}`}
                      >
                        Update Details
                      </Link>
                    </MenuItem>,
                    <MenuItem
                      key="members"
                      //onClick={() => console.info(row.id)}
                    >
                      <Link
                        className="dropdown-item"
                        to={`/admin/clinicalmanagement/healthcenters/staff/${row.id}`}
                      >
                        View Clinic Staffs
                      </Link>
                    </MenuItem>,
                  ]} // action columns menu items
                  muiTableContainerProps={{
                    sx: {
                      maxHeight: "60vh",
                    },
                  }}
                  enableStickyHeader
                />
              </div>
            )}
          </div>

          <CompanyListFilterPopup
            setJsonFilterQuery={setJsonFilterQuery}
            reloadList={resetFilterData}
            moduleSlug="healthcenterlist"
            isFilterReset={isFilterReset}
            setIsFilterReset={setIsFilterReset}
          />

          <AddLabelModal
            moduleName="companylist"
            selectedIds={selectedCompanyIds}
            afterTagModalClose={afterModalActionClose}
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
            onModalClose={() => {
              setSelectedCompanyIds([]);
              setRowSelection({});
            }}
          />

          <DeleteWarningModal
            onCancelDelete={() => {
              setRowSelection({});
              setSelectedCompanyIds([]);
            }}
            onDelete={bulkDeleteHandler}
            moduleName={t("health center")}
          />

          {showAlert && (
            <AlertNotification
              showAlert={showAlert}
              message={alertMessage}
              alertType={messageType}
              onClose={onAlertClose}
            />
          )}
        </section>
      </div>
    );
  } else {
    return <AccessDeniedView />;
  }
};

export default HealthCentersListBody;
